import { render, staticRenderFns } from "./MarketplaceLeadsTableLite.vue?vue&type=template&id=458b01a4&scoped=true&"
import script from "./MarketplaceLeadsTableLite.vue?vue&type=script&lang=js&"
export * from "./MarketplaceLeadsTableLite.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceLeadsTableLite.vue?vue&type=style&index=0&id=458b01a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458b01a4",
  null
  
)

export default component.exports